import {
  OrderManagementPermissions,
  SettingsPermissions,
} from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { NotFoundPage } from "@redotech/redo-web/login/not-found-page";
import { memo } from "react";
import { Navigate } from "react-router-dom";
import { useDocumentsAccess } from "./documents-access";
import { getPersonalizedInsertRouteChildren } from "./personalized-insert-routes";

const DocumentsIndexRedirect = memo(function DocumentsIndexRedirect() {
  const { landingDestination } = useDocumentsAccess();
  return landingDestination ? (
    <Navigate replace to={landingDestination} />
  ) : (
    <NotFoundPage />
  );
});

export const documentRoutes: PermissionedRouteObject[] = [
  { index: true, element: <DocumentsIndexRedirect /> },
  {
    path: "packing-slips",
    handle: {
      breadcrumb: "Packing slips",
      permission: SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    },
    children: [
      {
        index: true,
        async lazy() {
          const { PackingSlipsPage } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-merchant-fulfillment-app/packing-slips/packing-slips-page");
          return { Component: PackingSlipsPage };
        },
      },
      {
        path: ":packingSlipId",
        handle: { breadcrumb: "Packing slip builder" },
        async lazy() {
          const { PackingSlipBuilder } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-merchant-fulfillment-app/packing-slips/packing-slip-builder");
          return { Component: PackingSlipBuilder };
        },
      },
    ],
  },
  {
    path: "personalized-inserts",
    handle: {
      breadcrumb: "Personalized inserts",
      permission: OrderManagementPermissions.MANAGE_SHIPMENTS,
    },
    children: getPersonalizedInsertRouteChildren(),
  },
  {
    path: "pick-lists",
    handle: {
      breadcrumb: "Pick lists",
      hideHeader: true,
      permission: SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    },
    async lazy() {
      const { PickListDesignerPage } =
        // redont-allow-dynamic-import: route-level code splitting
        await import("@redotech/redo-merchant-fulfillment-app/setting/printing-document-designers");
      return { Component: PickListDesignerPage };
    },
  },
  {
    path: "shipping-labels",
    handle: {
      breadcrumb: "Shipping labels",
      hideHeader: true,
      permission: SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    },
    async lazy() {
      const { ShippingLabelDesignerPage } =
        // redont-allow-dynamic-import: route-level code splitting
        await import("@redotech/redo-merchant-fulfillment-app/setting/printing-document-designers");
      return { Component: ShippingLabelDesignerPage };
    },
  },
];
